import { takeLatest, put, call } from 'redux-saga/effects';
import graphFetch from '../../util/graphFetch';
import {
    removePageSuccess,
    fetchPageSuccess,
    createOrUpdatePageSuccess,
} from '../actions';

import { pageTypes } from '../actionTypes';

function* removePage({ payload }) {
    const { pageId, onSuccess } = payload;
    try {
        const mutation = true;
        const options = {
            queryName: 'removePage',
            select: 'message success',
            args: {
                id: { value: pageId, type: 'ID!' },
            },
        };
        const result = yield call(graphFetch, options, mutation);
        if (result?.data?.removePage?.success) {
            yield put(removePageSuccess(payload));
            onSuccess();
        }
    } catch (err) {
        console.log(err);
    }
}

function* fetchPage({ pageId }) {
    try {
        const options = {
            queryName: 'page',
            select: 'id data',
            args: {
                id: { value: pageId, type: 'ID!' },
            },
        };
        const result = yield call(graphFetch, options);

        if (result?.data?.page) {
            yield put(fetchPageSuccess(result.data.page));
        }
    } catch (err) {
        console.log(err);
    }
}

function* createOrUpdatePage({ siteId, page, history }) {
    try {
        const options = {
            queryName: 'createOrUpdatePage',
            select: 'success message page { id name slug }',
            args: {
                siteId: { value: siteId, type: 'ID!' },
                page: { value: page, type: 'PageInput!' },
            },
        };
        const result = yield call(graphFetch, options, true);

        if (result?.data?.createOrUpdatePage?.success) {
            yield put(
                createOrUpdatePageSuccess({
                    siteId,
                    isNew: !page.id,
                    ...result.data.createOrUpdatePage,
                })
            );
            if (!page.id) {
                history.push(
                    `/builder/site/${siteId}/page/${result.data.createOrUpdatePage.page.id}`
                );
            }
        }
    } catch (err) {
        console.log(err);
    }
}

export default [
    takeLatest(pageTypes.FETCH_PAGE_REQUEST, fetchPage),
    takeLatest(pageTypes.REMOVE_PAGE_REQUEST, removePage),
    takeLatest(pageTypes.CREATE_PAGE_REQUEST, createOrUpdatePage),
];
